// extracted by css-extract-rspack-plugin
export default {"Grid":"MyAchievements_Grid__sBQRO"};